//Module Keys
let locales = {};

//Merge Views

//Main
import main from '../../views/main/lan/en';
locales = { ...locales, ...main };

import customerTab from "../../views/customerTab/lan/en";
locales = { ...locales, ...customerTab };

import trackerTab from '../../views/trackerTab/lan/en';
locales = { ...locales, ...trackerTab };

import createEditWorkOrder from '../../views/trackerTab/modals/createEditWorkOrder/lan/en'
locales = { ...locales, ...createEditWorkOrder };

import createEditCustomer from '../../views/customerTab/modals/createEditCustomer/lan/en'
locales = { ...locales, ...createEditCustomer };

import createEditContact from '../../views/contactTab/modals/createEditContact/lan/en';
locales = { ...locales, ...createEditContact };

import createEditLocation from '../../views/locationTab/modals/createEditLocation/lan/en';
locales = { ...locales, ...createEditLocation };

import customerSelector from '../../views/trackerTab/modals/customerSelector/lan/en';
locales = { ...locales, ...customerSelector };

import deleteCustomer  from '../../views/customerTab/modals/deleteCustomer/lan/en';
locales = { ...locales, ...deleteCustomer };

import customerDetail from '../../views/customerDetail/lan/en';
locales = { ...locales, ...customerDetail };

import workOrderTab from '../../views/workOrderTab/lan/en';
locales = { ...locales, ...workOrderTab };

import contactTab from '../../views/contactTab/lan/en';
locales = { ...locales, ...contactTab };

import locationTab from '../../views/locationTab/lan/en';
locales = { ...locales, ...locationTab };

import schedule from '../../views/schedule/lan/en';
locales = { ...locales, ...schedule };

import advancedFilters from '../../views/workOrderTab/modals/advancedFilters/lan/en';
locales = { ...locales, ...advancedFilters };

import deleteLocation from '../../views/locationTab/modals/deleteLocation/lan/en';
locales = { ...locales, ...deleteLocation };

import deleteContact from '../../views/contactTab/modals/deleteContact/lan/en';
locales = { ...locales, ...deleteContact };

import importCustomers from '../../views/customerTab/modals/importCustomers/lan/en';
locales = { ...locales, ...importCustomers };

import driverSelector from '../../views/trackerTab/modals/driverSelector/lan/en';
locales = { ...locales, ...driverSelector };

import createEditWorkOrderSettings from '../../views/trackerTab/modals/createEditWorkOrder/views/settings/lan/en';
locales = { ...locales, ...createEditWorkOrderSettings };

import deleteWorkOrder from '../../views/trackerTab/modals/deleteWorkOrder/lan/en';
locales = { ...locales, ...deleteWorkOrder };

import createEditWorkOrderComments from '../../views/trackerTab/modals/createEditWorkOrder/views/comments/lan/en';
locales = { ...locales, ...createEditWorkOrderComments };

import createEditWorkOrderHistoryLogs from '../../views/trackerTab/modals/createEditWorkOrder/views/historyLogs/lan/en';
locales = { ...locales, ...createEditWorkOrderHistoryLogs };

import changeStatus from '../../views/trackerTab/modals/changeStatus/lan/en';
locales = { ...locales, ...changeStatus };

export default locales;